import {
  useCreate,
  useDelete,
  useDetail,
  useList,
  useUpdate,
  usePartialUpdate,
} from '@inmagik/react-crud'
import { Esportazione } from '../types'
import { API_URL } from '../constants'

export function useEsportazioniList(params: Record<string, string> = {}) {
  return useList<Esportazione>(`${API_URL}/bilance/esportazione`, params)
}

export function useEsportazione(id: string) {
  return useDetail<Esportazione>(`${API_URL}/bilance/esportazione`, id)
}

export function useCreateEsportazione() {
  return useCreate<Esportazione>(`${API_URL}/bilance/esportazione`)
}

export function useUpdateEsportazione() {
  return useUpdate<Esportazione>(`${API_URL}/bilance/esportazione`)
}

export function usePartialUpdateEsportazione() {
  return usePartialUpdate<Esportazione>(`${API_URL}/bilance/esportazione`)
}

export function useDeleteEsportazione() {
  return useDelete(`${API_URL}/bilance/esportazione`)
}
